import { Box, Button, HStack, Input, InputGroup, Slider, Text, Wrap } from '@chakra-ui/react';
import { CurrencyInput } from '@src/components/sco/CurrencyInput';
import { DiagnosticColumns } from '@src/components/sco/Funding/FundingLandingDiagnostic/DiagnosticShell';
import { AccentHeading, ChoiceChip, FieldLabel, Panel, ProofStats, WhyWeAsk } from '@src/components/sco/Funding/FundingLandingDiagnostic/shared';
import { FundingLandingDiagnosticAdditionalFields, PRODUCT_STAGES } from '@src/components/sco/Funding/FundingLandingDiagnostic/types';
import { useRequestFunnelContext } from '@src/components/sco/RequestFunnel/RequestFunnelContext';
import tracker from '@src/lib/tracker';
import React, { useEffect } from 'react';
import { LuChevronRight } from 'react-icons/lu';
export const TractionStep: React.FC = () => {
  const {
    signupRequest,
    updateSignupRequest,
    setStep,
    saveSignupRequest
  } = useRequestFunnelContext();
  const additionalFields = (signupRequest.additionalFields || {}) as FundingLandingDiagnosticAdditionalFields;
  const foundStage = PRODUCT_STAGES.findIndex(s => s === additionalFields.productStage);
  const stageIndex = foundStage >= 0 ? foundStage : 2;
  const hasRevenue = additionalFields.hasRevenue;
  useEffect(() => {
    tracker.funnelStep(2);
    if (!additionalFields.productStage) {
      updateSignupRequest({
        additionalFields: {
          productStage: PRODUCT_STAGES[2]
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <DiagnosticColumns left={<>
          <AccentHeading accent={"Let's talk traction."} line1={'Almost there.'} />
          <WhyWeAsk items={["This doesn't need to be perfect", 'Product readiness aligns investor stage', 'Revenue shifts which investors we target']} />
          <ProofStats />
        </>} right={<>
          <Panel>
            <FieldLabel>
              Where is the{' '}
              <Box as={'span'} fontWeight={'extrabold'}>
                product
              </Box>{' '}
              right now?
            </FieldLabel>
            <Box paddingY={2} width={'full'}>
              <Slider.Root colorPalette={'orange'} max={PRODUCT_STAGES.length - 1} min={0} size={'md'} step={1} value={[stageIndex]} onValueChange={details => {
          const next = PRODUCT_STAGES[details.value[0]];
          updateSignupRequest({
            additionalFields: {
              productStage: next
            }
          });
        }}>
                <Slider.Control>
                  <Slider.Track>
                    <Slider.Range />
                  </Slider.Track>
                  <Slider.Thumb index={0}>
                    <Slider.HiddenInput />
                  </Slider.Thumb>
                </Slider.Control>
              </Slider.Root>
              <HStack colorPalette={'orange'} justify={'space-between'} marginTop={2}>
                {PRODUCT_STAGES.map((stage, i) => <Text key={stage} color={i === stageIndex ? 'colorPalette.solid' : 'fg.muted'} cursor={'pointer'} fontSize={'xs'} fontWeight={i === stageIndex ? 'bold' : 'semibold'} textAlign={'start'} onClick={() => updateSignupRequest({
            additionalFields: {
              productStage: stage
            }
          })}>
                    {stage}
                  </Text>)}
              </HStack>
            </Box>

            <FieldLabel>
              Do you have{' '}
              <Box as={'span'} fontWeight={'extrabold'}>
                revenue
              </Box>
              ?
            </FieldLabel>
            <Wrap gap={2} justify={'flex-start'}>
              <ChoiceChip active={hasRevenue === false} onClick={() => updateSignupRequest({
          additionalFields: {
            hasRevenue: false,
            revenueAmountLabel: null
          }
        })}>
                Not yet
              </ChoiceChip>
              <ChoiceChip active={hasRevenue === true} onClick={() => updateSignupRequest({
          additionalFields: {
            hasRevenue: true
          }
        })}>
                Yes
              </ChoiceChip>
            </Wrap>
            {hasRevenue === true && <>
                <FieldLabel>Great! How much annual revenue?</FieldLabel>
                <InputGroup startAddon={'$'} width={'full'}>
                  <Input asChild size={'lg'}>
                    <CurrencyInput decimalPlaces={0} placeholder={'10,000'} textAlign={'start'} numericValue={additionalFields.revenueAmountLabel ? parseInt(String(additionalFields.revenueAmountLabel), 10) : null} onNumericValueChange={value => updateSignupRequest({
              additionalFields: {
                revenueAmountLabel: value
              }
            })} />
                  </Input>
                </InputGroup>
              </>}
          </Panel>
          <Button fontWeight={'bold'} size={'xl'} variant={'cta'} width={'full'} onClick={() => {
      void saveSignupRequest(() => setStep('analyzing'), {
        additionalFields: signupRequest.additionalFields,
        fundingGoalInDollars: signupRequest.fundingGoalInDollars,
        investorIndustryTagTitles: signupRequest.investorIndustryTagTitles,
        location: signupRequest.location,
        locationCity: signupRequest.locationCity,
        locationCountryKey: signupRequest.locationCountryKey,
        locationPostalCode: signupRequest.locationPostalCode,
        locationState: signupRequest.locationState
      });
    }}>
            Generate Report
            <LuChevronRight />
          </Button>
        </>} />;
};